import { AxiosResponse } from 'axios';
import LoginService from 'pages/login/login.service';
import { FichaImagemAssociacao } from 'redux/features/imagemReducer';
import { axiosRequest } from './../axios/axios.config';

export enum TipoImagem {
    DESENHO_TECNICO = "DESENHO_TECNICO",
    PRODUTO_ACABADO = "PRODUTO_ACABADO",
    SERVICO = "SERVICO",
    PLATAFORMA_VENDA = "PLATAFORMA_VENDA"
}

export type FichaImagemRequest = {
    uuidProduto: string;
    tipos: Array<TipoImagem>,
    isThumb: boolean
}

const ProdutoService = () => {
    const produto = "produto"
    const loginService = LoginService();


    const getImagensProdutoFull = (toSearch: Array<String>): Promise<AxiosResponse<Array<FichaImagemAssociacao>>> => {
        return axiosRequest.post(`${produto}/imagens`, toSearch, { headers: loginService.getHeaders() })
    }

    return {
        getImagensProdutoFull
    };
};

export default ProdutoService;
